import {gsap} from "gsap";
import {BruteForceWinConfigs, IBigWinLevel} from "../BruteForceWinConfigs";
import {BruteForce} from "../BruteForce";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";
import {BruteForceSound} from "../sound/BruteForceSound";

export class BruteForceBigWinPresentation implements SimplePresentation {
    private _bigWinLevels: IBigWinLevel[];

    constructor() {
    }

    shouldRun(): boolean {

        return BruteForce.model.isBigWin;
    }

    start(controller: SimplePresentationRunnerController): void {
        const levels: IBigWinLevel[] = this._bigWinLevels = BruteForceWinConfigs.getBigWinLevels(BruteForce.model.currentWinRatio),
            maxLevel: number = levels.length;
        BruteForce.bigWinView.maxLevel = maxLevel;

        const totalWin: number = BruteForce.model.gameData.totalSpinWinnings,
            tl: gsap.core.Timeline = gsap.timeline();

        controller.setSkipCallback(() => {
            tl.seek("prebigwinShake_end", false);
            BruteForceSound.stopSound(BruteForceSound.BIGWIN_INTRO);
        }); //think about skip,maybe not skip this?
        BruteForce.betlineView.hideLinesAndAmount();
        tl.add(BruteForce.bigWinView.show(0.05));
        tl.add(BruteForce.bigWinView.startCountUp(15 * BruteForce.model.gameData.playedBetValue));
        tl.add([BruteForce.allreelsView.shakeReelArea(), BruteForce.reelOverlayView.shakeReelOverlay()], 0);
        tl.add(BruteForce.reelScreenDarkOverlay.addOverlay());
        tl.addLabel("prebigwinShake_end"); // think about timing

        for (let index: number = 0; index < levels.length; index++) {
            const bigWinLevel: IBigWinLevel = levels[index],
                from: number = bigWinLevel.from * BruteForce.model.gameData.playedBetValue,
                to: number = ((index + 1) === maxLevel) ? totalWin : bigWinLevel.to * BruteForce.model.gameData.playedBetValue,
                levelStartTime = tl.duration();
            if (index === 0) {
                BruteForceSound.fadeMusic(0, 0.5)
            }
            tl.add(() => {
                controller.setSkipCallback(() => {
                    BruteForce.bigWinView.onAbort(bigWinLevel.id - 1);
                    tl.seek(bigWinLevel.name + "_end", false);
                });
            }, levelStartTime);
            tl.add(BruteForce.bigWinView.getLevelAnimation(from, to, bigWinLevel.duration, bigWinLevel.id), levelStartTime);
            tl.addLabel(bigWinLevel.name + "_end");
        }

        if (!BruteForce.model.brokeTheBank) {
            tl.add(BruteForce.bigWinView.hide());
        }
        tl.add(() => {
            controller.setSkipCallback();
            controller.finish()
        });

    }
}